import React, { useState } from 'react';
import {
  Box,
  Typography,
  Divider,
  TextField,
  InputAdornment,
  Button,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Switch from 'react-switch';
import { useTranslation } from 'react-i18next';
import Collapse from '@material-ui/core/Collapse';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

export default function FloodforecastSidebar({ 
  layers,
  setLayers,
  showProvinceBoundary,
  setShowProvinceBoundary,
  showAmphoeBoundary,
  setShowAmphoeBoundary,
  showTambonBoundary,
  setShowTambonBoundary,
  rainfallEnabled,
  setRainfallEnabled,
  forecastDay,
  setForecastDay,
  sidebarOpen,
  setSidebarOpen,
  forecastRainEnabled,
  setForecastRainEnabled,
  forecastRainDay,
  setForecastRainDay,
  forecastOptions,
  datas,
  datasDischarge,
  onStationSelect,
  onBasinSelect,
  geojsonBasin,
 }) {

  const { t } = useTranslation();
  const [openBoundary, setOpenBoundary] = useState(true);
  const [provinceBoundary, setProvinceBoundary] = useState(false);
  const [amphoeBoundary, setAmphoeBoundary] = useState(false);
  const [tambonBoundary, setTambonBoundary] = useState(false);
  const [search, setSearch] = useState('');

  const handleToggle = (id, checked) => {
    setLayers((prev) => ({
      ...prev,
      [id]: checked,
    }));
  };

  const layerItems = [
    {
      id: 'basin',
      title: t('ลุ่มน้ำ'),
      subtitle: t('22 ลุ่มน้ำหลัก'),
    },
    {
      id: 'river',
      title: t('เส้นแม่น้ำ'),
      subtitle: t('โครงข่ายลำน้ำ'),
    },
  ];

  const allStations = [
    ...(datas || []).filter(d => d[0] && d[0] !== 'code' && d[0] !== '-').map(d => ({
      id: d[0],
      name: d[2],
      lat: d[3],
      lng: d[4],
      province: d[13],
      type: 'waterLevel',
    })),
    ...(datasDischarge || []).filter(d => d[0] && d[0] !== 'code' && d[0] !== '-').map(d => ({
      id: d[0],
      name: d[2],
      lat: d[3],
      lng: d[4],
      province: d[13],
      type: 'discharge',
    })),
    ...(geojsonBasin?.features || []).map(f => ({
      id: f.properties.BASIN_CODE,
      name: f.properties.BASIN_T,
      lat: null,
      lng: null,
      province: null,
      type: 'basin',
    }))
  ];

  const filtered = search.trim()
    ? allStations.filter(s =>
        s.id.toLowerCase().includes(search.toLowerCase()) ||
        s.name.toLowerCase().includes(search.toLowerCase()) ||
        (s.province ?? '').toLowerCase().includes(search.toLowerCase())
      )
    : [];

  return (
    <div
      style={{
        width: sidebarOpen ? 356 : 0,
        minWidth: sidebarOpen ? 356 : 0,
        height: '100%',
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
        border: sidebarOpen ? '1px solid #BBCEDAE5' : 'none',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.25s ease, min-width 0.25s ease',
      }}
    >
      <Box
        p={2}
        style={{
          overflowY: 'auto',
          height: '100%',
        }}
      >
        {/* ================= Search ================= */}

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
          mb={1}
        >
          <Box>
            <Typography
              style={{
                fontFamily: 'Kanit',
                fontWeight: 400,
                color: '#7890A3',
                fontSize: 10,
              }}
            >
              {t('ค้นหาสถานี')}
            </Typography>

            <Typography
              style={{
                fontFamily: 'Kanit',
                fontWeight: 700,
                fontSize: 15,
                lineHeight: '24px',
              }}
            >
              {t('พื้นที่และสถานี')}
            </Typography>
          </Box>

          <Button
            onClick={() => setSidebarOpen(false)}
            style={{
              minWidth: 36,
              width: 36,
              height: 36,
              padding: 6,
              borderRadius: 8,
              border: '1px solid #CCCCCC',
              background: '#F7F7F7D9',
              marginBottom: 2,
            }}
          >
            <ChevronLeftIcon style={{ fontSize: 24, color: '#000000', transition: 'transform 0.25s ease', transform: sidebarOpen ? 'rotate(0deg)' : 'rotate(180deg)',}} />
          </Button>
        </Box>

        <TextField
          fullWidth
          variant="outlined"
          placeholder={t('ชื่อรหัส จังหวัด หรือลุ่มน้ำ')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon
                  style={{
                    color: '#9CA3AF',
                    transform: 'scaleX(-1)',
                    fontSize: 14,
                  }}
                />
              </InputAdornment>
            ),
            style: {
              borderRadius: 9,
              backgroundColor: '#FFFFFF',
              height: 40,
              fontFamily: 'Kanit',
            },
          }}
        />

        {filtered.length > 0 && (
          <Box
            style={{
              border: '1px solid #DBE5EC',
              borderRadius: 8,
              marginTop: 4,
              maxHeight: 200,
              overflowY: 'auto',
              backgroundColor: '#fff',
              zIndex: 9999,
            }}
          >
            {filtered.map((s) => (
              <Box
                key={`${s.type}-${s.id}`}
                px={2}
                py={1}
                style={{ cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                onClick={() => {
                  if (s.type === 'basin') {
                    onBasinSelect(s.id);
                  } else {
                    onStationSelect(parseFloat(s.lat), parseFloat(s.lng));
                  }
                  setSearch('');
                }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <Typography style={{ fontFamily: 'Kanit', fontSize: 12, fontWeight: 500 }}>
                  {s.type === 'basin' ? s.name : `${s.id} ${s.name}`}
                </Typography>
                <Typography style={{ fontFamily: 'Kanit', fontSize: 10, color: '#6B7280' }}>
                  {s.type === 'waterLevel' ? 'ระดับน้ำ' : s.type === 'discharge' ? 'ปริมาณน้ำ' : 'ลุ่มน้ำ'} • {s.province ?? ''}
                </Typography>
              </Box>
            ))}
          </Box>
        )}

        <Box mt={2} display="flex" flexDirection="column" style={{ gap: 8 }}>
          {[
            { id: 'waterLevel', title: t('สถานีระดับน้ำ'), subtitle: t('สถานีตรวจวัด') },
            { id: 'discharge',  title: t('สถานีปริมาณน้ำ'), subtitle: t('สถานีตรวจวัด') },
          ].map((layer) => (
            <Box
              key={layer.id}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box mb={1}>
                <Typography style={{ fontFamily: 'Kanit', fontWeight: 500, fontSize: 12 }}>
                  {layer.title}
                </Typography>
                <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#6B7280' }}>
                  {layer.subtitle}
                </Typography>
              </Box>
              <Switch
                checked={layers[layer.id]}
                onChange={(checked) => handleToggle(layer.id, checked)}
                height={19}
                width={34}
                handleDiameter={13}
                onColor="#2196F3"
                offColor="#D9D9D9"
                checkedIcon={false}
                uncheckedIcon={false}
              />
            </Box>
          ))}
        </Box>

        <Divider
          style={{
            marginTop: 10,
            marginBottom: 20,
            marginLeft: -16,
            marginRight: -16,
            backgroundColor: '#DBE5EC',
          }}
        />

        {/* ================= Layer ================= */}

        <Typography
          style={{
            fontFamily: 'Kanit',
            fontWeight: 400,
            color: '#7890A3',
            fontSize: 13,
          }}
        >
          {t('ชั้นข้อมูล')}
        </Typography>

        <Typography
          style={{
            fontFamily: 'Kanit',
            fontWeight: 700,
            fontSize: 15,
            marginBottom: 10,
          }}
        >
          {t('การแสดงผลบนแผนที่')}
        </Typography>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box>
            <Typography style={{ fontFamily: 'Kanit', fontWeight: 500, fontSize: 12 }}>{t('ฝนตรวจวัด')}</Typography>
            <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#6B7280' }}>{t('สถานีตรวจวัด')}</Typography>
          </Box>
          <Switch checked={rainfallEnabled} onChange={(checked) => setRainfallEnabled(checked)}
            height={19} width={34} handleDiameter={13} onColor="#2196F3" offColor="#D9D9D9" checkedIcon={false} uncheckedIcon={false} />
        </Box>
        {rainfallEnabled && (
          <Box mb={2}>
            <FormControl fullWidth variant="outlined" size="small">
              <Select value={forecastDay} onChange={(e) => setForecastDay(e.target.value)}
                style={{ height: 36, fontFamily: 'Kanit', fontSize: 12 }}>
                <MenuItem value={1}>วานนี้</MenuItem>
                <MenuItem value={2}>วันนี้</MenuItem>
                <MenuItem value={3}>24 ชั่วโมง</MenuItem>
                <MenuItem value={4}>3 วัน</MenuItem>
                <MenuItem value={5}>7 วัน</MenuItem>
                <MenuItem value={6}>15 วัน</MenuItem>
                <MenuItem value={7}>30 วัน</MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box>
            <Typography style={{ fontFamily: 'Kanit', fontWeight: 500, fontSize: 12 }}>{t('ฝนคาดการณ์')}</Typography>
            <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#6B7280' }}>{t('ล่วงหน้า 1–6 วัน')}</Typography>
          </Box>
          <Switch checked={forecastRainEnabled} onChange={(checked) => setForecastRainEnabled(checked)}
            height={19} width={34} handleDiameter={13} onColor="#2196F3" offColor="#D9D9D9" checkedIcon={false} uncheckedIcon={false} />
        </Box>
        {forecastRainEnabled && (
          <Box mb={2}>
            <FormControl fullWidth variant="outlined" size="small">
              <Select value={forecastRainDay} onChange={(e) => setForecastRainDay(e.target.value)}
                style={{ height: 36, fontFamily: 'Kanit', fontSize: 12 }}>
                {forecastOptions.map((item) => (
                  <MenuItem key={item.value} value={item.value} style={{ fontFamily: 'Kanit', fontSize: 12 }}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}

        {layerItems.map((layer) => (
          <Box key={layer.id} display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Box>
              <Typography style={{ fontFamily: 'Kanit', fontWeight: 500, fontSize: 12 }}>{layer.title}</Typography>
              <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#6B7280' }}>{layer.subtitle}</Typography>
            </Box>
            <Switch checked={layers[layer.id]} onChange={(checked) => handleToggle(layer.id, checked)}
              height={19} width={34} handleDiameter={13} onColor="#2196F3" offColor="#D9D9D9" checkedIcon={false} uncheckedIcon={false} />
          </Box>
        ))}
        
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            style={{
              cursor: 'pointer',
            }}
            onClick={() => setOpenBoundary(!openBoundary)}
          >
            <Box>
              <Typography
                style={{
                  fontFamily: 'Kanit',
                  fontWeight: 500,
                  fontSize: 12,
                }}
              >
                {t('ขอบเขตการปกครอง')}
              </Typography>

              <Typography
                style={{
                  fontFamily: 'Kanit',
                  fontWeight: 400,
                  fontSize: 9,
                  color: '#7890A3',
                }}
              >
                {t('ขอบเขตการปกครอง')}
              </Typography>
            </Box>

            <IconButton size="small">
              {openBoundary ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardArrowRightIcon />
              )}
            </IconButton>
          </Box>

          <Collapse in={openBoundary}>
            <Box ml={1}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  style={{
                    fontFamily: 'Kanit',
                    fontSize: 12,
                  }}
                >
                  • {t('ขอบเขตจังหวัด')}
                </Typography>

                <Checkbox
                  checked={showProvinceBoundary}
                  onChange={(e) => setShowProvinceBoundary(e.target.checked)}
                  color="primary"
                  size="small"
                />
              </Box>

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  style={{
                    fontFamily: 'Kanit',
                    fontSize: 12,
                  }}
                >
                  • {t('ขอบเขตอำเภอ')}
                </Typography>

                <Checkbox
                  checked={showAmphoeBoundary}
                  onChange={(e) => setShowAmphoeBoundary(e.target.checked)}
                  color="primary"
                  size="small"
                />
              </Box>

              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography
                  style={{
                    fontFamily: 'Kanit',
                    fontSize: 12,
                  }}
                >
                  • {t('ขอบเขตตำบล')}
                </Typography>

                <Checkbox
                  checked={showTambonBoundary}
                  onChange={(e) => setShowTambonBoundary(e.target.checked)}
                  color="primary"
                  size="small"
                />
              </Box>
            </Box>
          </Collapse>
        </Box>
      </Box>
    </div>
  );
}